import React from 'react';
import type { SegmentRulePayload } from '@/types/chat';

/** Compact read-only list of a segment's match/exclude rules. Shared by the
 *  segment proposal + update cards. */
const SegmentRuleList: React.FC<{ label: string; rules: SegmentRulePayload[] }> = ({ label, rules }) => {
  if (!rules || rules.length === 0) return null;
  return (
    <div>
      <div className="text-xs uppercase tracking-wide text-muted-foreground mb-1">{label}</div>
      <ul className="space-y-1">
        {rules.map((rule, i) => (
          <li key={i} className="flex items-center gap-2 text-xs">
            <span className="font-mono px-1.5 py-0.5 rounded bg-accent text-primary whitespace-nowrap">
              {rule.type}
            </span>
            <span className="font-mono text-foreground truncate">{rule.value}</span>
            {rule.weight !== undefined && rule.weight !== 1 && (
              <span className="text-muted-foreground whitespace-nowrap">×{rule.weight}</span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SegmentRuleList;
